var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"APP",attrs:{"id":"app"}},[_c('div',{staticClass:"cursor-follower",style:({ 
      left: (_vm.cursorX - 1.5) + 'px', 
      top: (_vm.cursorY - 4) + 'px',
      display: _vm.cursorVisible ? 'block' : 'none'
    })},[_c('img',{attrs:{"src":_vm.cursorImage,"alt":"鼠标跟随"},on:{"error":_vm.handleImageError}})]),_c('router-view'),_c('BackTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }